const config = {
  breakpoint: {
    xsMax: '575.98',
    smMin: '576',
    smMax: '767.98',
    mdMin: '768',
    mdMax: '1023.98',
    lgMin: '1024',
    lgMax: '1769.98',
    xlMin: '1770'
  }
};

export {
  config
}